import { selectIsLoading } from '@store/loaders'
import { MessagesActions } from '@store/messagesSaga'
import { UpgradePlanActions } from '@store/reducers/upgradePlan'
import { useDispatch, useSelector } from 'react-redux'

import { isProPlan, isTeamPlan } from '@/constants/userSubscriptionPlans'
import { useAuth } from '@/hooks'
import { isActiveMonthlyPlan } from '@/utils'

export const useAnnualPlanCallout = () => {
  const dispatch = useDispatch()
  const loading = useSelector(selectIsLoading('upgrade_plan'))

  const { planId, planType, messages, subscriptionStatus } = useAuth()

  const proPlan = isProPlan(planId)
  const teamPlan = isTeamPlan(planId)
  const eligiblePlan = isActiveMonthlyPlan(planId, planType, subscriptionStatus)

  const message = messages.find((m) => m.type === 'switch_to_annual')
  const hasMessage = Boolean(message && eligiblePlan)
  const messageId = message?.id

  const onCloseClick = () => {
    if (!messageId) {
      return
    }

    dispatch(MessagesActions.viewed({ id: messageId }))
  }

  const onClick = () => {
    if (!hasMessage) {
      return
    }

    dispatch(UpgradePlanActions.updatePayment({ planId, planType: 'annual' }))
  }

  return {
    proPlan,
    teamPlan,
    hasMessage,
    loading,
    onCloseClick,
    onClick,
  }
}
